var map = {
	"./music-instructions.json": 4464,
	"./music-library-intro2024.json": 4465,
	"./music-library-launch2024.json": 4466,
	"./music-progression.json": 4467,
	"./startSourcesAdvanced.json": 4468,
	"./startSourcesSimple.json": 4469,
	"./startSourcesSimple2.json": 4470,
	"./startSourcesTracks.json": 4471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4243;